/**
 * Cable Types (Structured Cabling) — centralized enums/options.
 * Status values come from communicationConfig.js (single source of truth).
 */

export const CABLE_MEDIA_TYPES = ['Copper', 'Fiber'];
export const CABLE_CATEGORIES = ['Cat5e', 'Cat6', 'Cat6A', 'OM3', 'OM4', 'OS2'];
export const CABLE_SHIELDING = ['UTP', 'FTP', 'STP', 'None'];
export const CABLE_JACKET_RATINGS = ['CMP', 'CMR', 'CM', 'LSZH', 'Outdoor'];

// Suggestions only for the flexible connector tag input (NOT an enforced list).
export const COMMON_CONNECTORS = ['RJ45', 'LC', 'SC', 'ST', 'MPO/MTP', 'MTRJ'];
